import React from 'react';
import HeroSection8 from '../sectionBlocks/HeroSection8';
import NFTItems from '../sectionBlocks/Product_all';
import RoadMap from '../sectionBlocks/RoadMapSection';
import Footer from '../sectionBlocks/Footer';

const Work = () => {
  return (
    <>
      <HeroSection8/>
      <NFTItems/>
      <RoadMap/>
      <Footer/>
    </>
  );
};

export default Work;